
// apenas números nos campos
function onlyNumbers(e, setFieldValue, fieldName) {
  const { value } = e.target;

  // Substituir vírgula por ponto
  if (e.key === ',') {
    e.preventDefault();
    setFieldValue(fieldName, `${value}.`);
    return;
  }

  // Permitir apenas números, ponto, backspace, delete, setas e tab
  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', '.', 'Tab'];
  if (!((e.key >= '0' && e.key <= '9') || allowedKeys.includes(e.key))) {
    e.preventDefault();
    return;
  }

  // Evitar múltiplos pontos
  if (e.key === '.' && value.includes('.')) {
    e.preventDefault();
    return;
  }

  // Limitar a duas casas decimais
  if (value.includes('.')) {
    const [integerPart, decimalPart] = value.split('.');
    if (decimalPart.length >= 2 && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  }
}

// não permitir envio do form ao pressionar enter
function handleKeyDown(e) {
  if (e.key === 'Enter') {
    e.preventDefault();
  }
}
//
function formatTime(time) {
  if (!time) return '';  // Verifica se 'time' é indefinido ou null e retorna uma string vazia
  return time.slice(0, 5);
}
// Função para retornar o ícone baseado no nome da refeição

const formatDietName = (diet_name) => {
  switch (diet_name) {
    case 'low_carb':
      return 'Dieta Low Carb';
    case 'keto':
      return 'Dieta Cetogênica';
    case 'caloric_deficit':
      return 'Dieta de Déficit Calórico';
    case 'intermittent_fasting':
      return 'Dieta do Jejum Intermitente';
    case '21_day_diet':
      return 'Dieta de 21 Dias';
    case 'detox':
      return 'Dieta Detox';
    case '7_day_detox':
      return 'Dieta Detox de 7 Dias';
    case 'hypercaloric':
      return 'Dieta Hipercalórica';
    case 'hypertrophic':
      return 'Dieta Hipertófica';
    case 'bulking':
      return 'Dieta Bulking';
    case 'protein_diet':
      return 'Dieta da Proteína';
    case 'lean_gain':
      return 'Dieta para Ganho Lean (Massa Magra)';
    case 'mediterranean':
      return 'Dieta Mediterrânea';
    case 'mediterranean_adapted':
      return 'Dieta Mediterrânea Adaptada';
    case 'antiinflammatory':
      return 'Dieta Antiinflamatória';
    case 'antioxidant':
      return 'Dieta Antioxidante';
    case 'high_fiber':
      return 'Dieta Rica em Fibras';
    case 'cardiovascular':
      return 'Dieta de Saúde Cardiovascular';
    case 'immune_boost':
      return 'Dieta para Imunidade';
    case 'vegan':
      return 'Dieta Vegana';
    case 'vegetarian':
      return 'Dieta Vegetariana';
    case 'flexitarian':
      return 'Dieta Flexitariana';
    case 'pescatarian':
      return 'Dieta Pescetariana';
    case 'paleo':
      return 'Dieta Paleo';
    case 'dash':
      return 'Dieta DASH (Hipertensão)';
    case 'fodmap':
      return 'Dieta FODMAP (Distúrbios Intestinais)';
    case 'diabetes':
      return 'Dieta para Diabetes';
    case 'low_sodium':
      return 'Dieta Hipossódica';
    case 'renal':
      return 'Dieta Renal (Insuficiência Renal)';
    default:
      return '';
  }
};
// Função para formatar a Data DD/MM/YYYY
const formatDate = (birth_date) => {
  if (!birth_date) return 'Data inválida';
  const date = new Date(birth_date);
  if (Number.isNaN(date)) return 'Data inválida';
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year} `;
};
//
const pluralize = (count, singular, plural) => {
  return `${count} ${count === 1 ? singular : plural}`;
};
// Função para calcular a Idade Ano Meses e Dias
const calculateAge = (birth_date) => {
  const today = new Date();
  const birthDate = new Date(birth_date);
  let years = today.getFullYear() - birthDate.getFullYear();
  let months = today.getMonth() - birthDate.getMonth();
  let days = today.getDate() - birthDate.getDate();

  if (days < 0) {
    months--;
    const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += lastMonth.getDate();
  }

  if (months < 0) {
    years--;
    months += 12;
  }

  return `${pluralize(years, 'Ano', 'Anos')} ${pluralize(months, 'mês', 'meses')} e ${pluralize(days, 'dia', 'dias')}`;
};
// Função para calcular o valor da consulta
const calculateFees = (base, charges, discounts) => {
  const baseValue = typeof base === 'string' ? parseFloat(base) || 0 : base;
  const chargesValue = typeof charges === 'string' ? parseFloat(charges) || 0 : charges;
  const discountsValue = typeof discounts === 'string' ? parseFloat(discounts) || 0 : discounts;

  return (baseValue + chargesValue - discountsValue).toFixed(2);
};

// Função para formatar o Gênero
const formatGender = (patientGender) => {
  switch (patientGender) {
    case 'male':
      return 'Masculino';
    case 'female':
      return 'Feminino';
    case 'others':
      return 'Outros';
    default:
      return '';
  }
}
//
const formatToMySQLDatetime = (dateString) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  if (isNaN(date)) return null;
  return date.toISOString().slice(0, 19).replace('T', ' ');
};

const tabFieldMapping = {
  'Nessa Consulta': ['consult_date', 'start_time', 'consultation_type_id', 'base_fee', 'additional_charges', 'discounts', 'final_fee'],
  '1 Objetivo da Consulta': ['objectiveQ1', 'objectiveQ2', 'objectiveQ3', 'consult_weight'],
  '2 Histórico Clínico Familiar': ['current_illnesses', 'past_illnesses', 'allergies', 'surgeries', 'medications', 'family_history'],
  '3 - Histórico Alimentar': ['foodHistoryQ1', 'foodHistoryQ2', 'foodHistoryQ3', 'foodHistoryQ4', 'foodHistoryQ5', 'foodHistoryQ6', 'foodHistoryQ7', 'foodHistoryQ8', 'foodHistoryQ9'],
  '4 - Hidratação': ['hydrationQ1', 'hydrationQ2', 'hydrationQ3'],
  '5 - Hábitos de Vida e Rotina': ['habitsQ1', 'habitsQ2', 'habitsQ3', 'habitsQ4', 'habitsQ5'],
  '6 - Fatores Emocionais / Comportamentais': ['emotionalFactorsQ1', 'emotionalFactorsQ2', 'emotionalFactorsQ3', 'emotionalFactorsQ4'],
  '7 - Suplementação e Vitaminas': ['supplementsQ1', 'supplementsQ2'],
  '8 - Planos e Expectativas': ['expectationsQ1', 'expectationsQ2', 'expectationsQ3'],
  '9 - Considerações Finais': ['procedures', 'diagnosis', 'observations'],
};

// Função para retornar o ícone baseado no nome da refeição
function formatStatus(status) {
  switch (status) {
    case 'scheduled':
      return "Agendada";
    case 'confirmed':
      return "Confirmada";
    case 'changed':
      return "Alterada";
    case 'in_progress':
      return "Em Progresso";
    case 'completed':
      return "Finalizda";
    case 'cancelled':
      return "Cancelada";
    default:
      return '';
  }
};

function formatedClassifyBray(classification) {
  switch (classification) {
    case 'Severe underweight grade III':
      return 'Magreza grave grau III';
    case 'Severe underweight grade II':
      return 'Magreza grave grau II';
    case 'Underweight grade I':
      return 'Magreza grau I';
    case 'Normal':
      return 'Normal';
    case 'Overweight':
      return 'Sobrepeso';
    case 'Obesity grade I':
      return 'Obesidade grau I';
    case 'Obesity grade II':
      return 'Obesidade grau II';
    case 'Obesity grade III':
      return 'Obesidade grau III';
    default:
      return '';
  }
}



module.exports = {
  onlyNumbers,
  handleKeyDown,
  formatTime,
  formatDietName,
  formatDate,
  calculateAge,
  calculateFees,
  formatGender,
  formatToMySQLDatetime,
  tabFieldMapping,
  formatStatus,
  formatedClassifyBray,
}